// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fdsf","colMin":"styles_colMin__NSoZ4"};